/**
 * Текст из значения неизвестного типа — для поиска, сравнения и подписей.
 *
 * `String(value)` для объекта даёт бессмысленное «[object Object]», и такие строки
 * молча попадали в ключи и подписи. Здесь примитивы становятся текстом как есть,
 * пустота — пустой строкой, дата — ISO-строкой, а прочие объекты — JSON, который
 * хотя бы читается.
 */
export function toText(value: unknown): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
    const primitive: number | boolean | bigint = value;
    return String(primitive);
  }
  if (value instanceof Date) return value.toISOString();
  if (typeof value === "object") return JSON.stringify(value) ?? "";
  return "";
}
